"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.diseasesMessages = exports.hasDiseaseMessages = exports.Diseases = exports.HasDisease = void 0;
const schema_1 = require("../../../../schema");
var HasDisease;
(function (HasDisease) {
    HasDisease["HAS_OTHER_DISORDER_DISEASE"] = "has_other_disorder_disease";
    HasDisease["NO_UNKNOWN_OTHER_DISORDER_DISEASE"] = "no_unknown_other_disorder_disease";
})(HasDisease || (exports.HasDisease = HasDisease = {}));
var Diseases;
(function (Diseases) {
    Diseases["COPD"] = "COPD";
    Diseases["ASTHMA_BRONCHIALE"] = "asthma_bronchiale";
    Diseases["GERD_ULCUS"] = "GERD_ulcus";
    Diseases["LIVER_FAILURE"] = "liver_failure";
    Diseases["DEMENTIA"] = "dementia";
    Diseases["AUTOIMMUN_BASELINE_DISEASE"] = "autoimmun_baseline_disease";
})(Diseases || (exports.Diseases = Diseases = {}));
exports.hasDiseaseMessages = {
    [HasDisease.HAS_OTHER_DISORDER_DISEASE]: {
        id: "ktx.transplantationScreening.medicalHistory.otherDisorders.hasDisease.HAS_OTHER_DISORDER_DISEASE",
        defaultMessage: "Diagnosztizált egyéb belgyógyászati betegség"
    },
    [HasDisease.NO_UNKNOWN_OTHER_DISORDER_DISEASE]: {
        id: "ktx.transplantationScreening.medicalHistory.otherDisorders.hasDisease.NO_UNKNOWN_OTHER_DISORDER_DISEASE",
        defaultMessage: "Nincs vagy nem ismert"
    }
};
exports.diseasesMessages = {
    [Diseases.COPD]: {
        id: "ktx.transplantationScreening.medicalHistory.otherDisorders.diseases.COPD",
        defaultMessage: "COPD"
    },
    [Diseases.ASTHMA_BRONCHIALE]: {
        id: "ktx.transplantationScreening.medicalHistory.otherDisorders.diseases.ASTHMA_BRONCHIALE",
        defaultMessage: "Asthma bronchiale"
    },
    [Diseases.GERD_ULCUS]: {
        id: "ktx.transplantationScreening.medicalHistory.otherDisorders.diseases.GERD_ULCUS",
        defaultMessage: "GERD / Ulcus"
    },
    [Diseases.LIVER_FAILURE]: {
        id: "ktx.transplantationScreening.medicalHistory.otherDisorders.diseases.LIVER_FAILURE",
        defaultMessage: "Májelégtelenség"
    },
    [Diseases.DEMENTIA]: {
        id: "ktx.transplantationScreening.medicalHistory.otherDisorders.diseases.DEMENTIA",
        defaultMessage: "Dementia"
    },
    [Diseases.AUTOIMMUN_BASELINE_DISEASE]: {
        id: "ktx.transplantationScreening.medicalHistory.otherDisorders.diseases.AUTOIMMUN_BASELINE_DISEASE",
        defaultMessage: "Autoimmun alapbetegség"
    }
};
const hasDisease = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(HasDisease.HAS_OTHER_DISORDER_DISEASE).interpretation({ vocab: "ktx", code: "has_other_disorder_disease" }),
    schema_1.Schema.singleChoiceItem(HasDisease.NO_UNKNOWN_OTHER_DISORDER_DISEASE)
        .interpretation({
        vocab: "ktx",
        code: "no_unknown_other_disorder_disease"
    })
        .tag({ vocab: "ktx", code: "medicine_diagnosis" })
]).interpretation({ vocab: "ktx", code: "has_other_disorder_disease_choice" });
const diseases = schema_1.Schema.ifThen(schema_1.Schema.expression(`{../hasDisease} === "has_other_disorder_disease"`), schema_1.Schema.multiChoice([
    schema_1.Schema.multiChoiceItem(Diseases.COPD)
        .interpretation({ vocab: "ktx", code: "COPD" })
        .tag({ vocab: "ktx", code: "medicine_diagnosis" }),
    schema_1.Schema.multiChoiceItem(Diseases.ASTHMA_BRONCHIALE)
        .interpretation({ vocab: "ktx", code: "asthma_bronchiale" })
        .tag({ vocab: "ktx", code: "medicine_diagnosis" }),
    schema_1.Schema.multiChoiceItem(Diseases.GERD_ULCUS)
        .interpretation({ vocab: "ktx", code: "GERD_ulcus" })
        .tag({ vocab: "ktx", code: "medicine_diagnosis" }),
    schema_1.Schema.multiChoiceItem(Diseases.LIVER_FAILURE)
        .interpretation({ vocab: "ktx", code: "liver_failure" })
        .tag({ vocab: "ktx", code: "medicine_diagnosis" }),
    schema_1.Schema.multiChoiceItem(Diseases.DEMENTIA)
        .interpretation({ vocab: "ktx", code: "dementia" })
        .tag({ vocab: "ktx", code: "medicine_diagnosis" }),
    schema_1.Schema.multiChoiceItem(Diseases.AUTOIMMUN_BASELINE_DISEASE)
        .interpretation({
        vocab: "ktx",
        code: "autoimmun_baseline_disease"
    })
        .tag({ vocab: "ktx", code: "medicine_diagnosis" })
]));
const comment = schema_1.Schema.string().optional().maxLength(10000);
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ hasDisease, diseases, comment })
    .interpretation({ vocab: "ktx", code: "other_disorder" });
